import { Spinner } from '@acpaas-ui/react-components';
import React from 'react';

const LoadingTableBody = ({ headerLength }) => (
  <tbody className="spo-o-table__body--loading">
    <tr>
      <td className="u-text-center" colSpan={headerLength}>
        <Spinner />
      </td>
    </tr>
  </tbody>
);

export default LoadingTableBody;
